<div class="auth-card">
  <div class="auth-card__header">
    <img class="auth-card__logo" [src]="authLogo" alt="logo" />
    <h1 class="auth-card__title">{{ 'login_title' | translate }}</h1>
    <p class="auth-card__subtitle">{{ 'login_subtitle' | translate }}</p>
  </div>

  <form class="auth-card__form" [formGroup]="loginForm" *ngIf="!is2FaRequired">
    <div class="auth-card__fields">
      <div class="auth-field">
        <label class="auth-field__label" for="login-username">{{ 'username' | translate }}</label>
        <input
          id="login-username"
          formControlName="username"
          required
          autocomplete="username"
          class="auth-field__input"
        />
        <mat-error *ngIf="username.invalid && username.touched">
          <span *ngIf="username.errors?.required">{{ 'please_enter_username' | translate }}</span>
          <span *ngIf="username.errors?.remote">{{ username.errors?.remote }}</span>
        </mat-error>
      </div>

      <div class="auth-field">
        <div class="auth-field__label-row">
          <label class="auth-field__label" for="login-password">{{ 'password' | translate }}</label>
          <a class="auth-field__link" routerLink="/auth/forgot-password">{{ 'forgot_password' | translate }}</a>
        </div>
        <input
          id="login-password"
          type="password"
          formControlName="password"
          required
          autocomplete="current-password"
          class="auth-field__input"
        />
        <mat-error *ngIf="password.invalid && password.touched">
          <span *ngIf="password.errors?.required">{{ 'please_enter_password' | translate }}</span>
          <span *ngIf="password.errors?.remote">{{ password.errors?.remote }}</span>
        </mat-error>
        <mat-error role="alert">
          <span *ngIf="credentialsError">{{ credentialsError }}</span>
        </mat-error>
      </div>
    </div>

    <button
      class="auth-card__submit"
      mat-raised-button
      [disabled]="!!loginForm.invalid"
      [loading]="isSubmitting"
      (click)="login()"
    >
      {{ 'login' | translate }}
    </button>

    <app-sso [redirectUrl]="redirectUrl"></app-sso>
  </form>

  <form class="auth-card__form" [formGroup]="twoFactorAuthForm" *ngIf="is2FaRequired">
    <div class="auth-card__fields">
      <div class="auth-field">
        <label class="auth-field__label" for="login-2fa">Enter your 2FA code</label>
        <input
          id="login-2fa"
          maxlength="6"
          type="text"
          formControlName="token"
          autocomplete="one-time-code"
          class="auth-field__input auth-field__input--mono"
        />
        <mat-error>
          <span *ngIf="token2faError">{{ token2faError }}</span>
        </mat-error>
      </div>
    </div>

    <button
      class="auth-card__submit"
      mat-raised-button
      [disabled]="!twoFactorAuthForm.valid"
      [loading]="isSubmitting"
      (click)="verify2Fa()"
    >
      Verify
    </button>
  </form>
</div>
